export const SUSPENSAOFORNECEDORES_LIST = 'SUSPENSAOFORNECEDORES_LIST';
export const SUSPENSAOFORNECEDORES_LIST_START =
  'SUSPENSAOFORNECEDORES_LIST_START';
export const SUSPENSAOFORNECEDORES_LIST_SUCCESS =
  'SUSPENSAOFORNECEDORES_LIST_SUCCESS';
export const SUSPENSAOFORNECEDORES_LIST_ERROR =
  'SUSPENSAOFORNECEDORES_LIST_ERROR';

export const TIPOSOCORRENCIAS_LIST = 'TIPOSOCORRENCIAS_LIST';
export const TIPOSOCORRENCIAS_LIST_START = 'TIPOSOCORRENCIAS_LIST_START';
export const TIPOSOCORRENCIAS_LIST_SUCCESS = 'TIPOSOCORRENCIAS_LIST_SUCCESS';
export const TIPOSOCORRENCIAS_LIST_ERROR = 'TIPOSOCORRENCIAS_LIST_ERROR';
